import React, { useRef } from 'react';
import { ChevronLeft } from 'lucide-react';
import Button from '../ui/Button';
import { useCourseForm } from '../../hooks/useCourseForm';
import { useToast } from '../../hooks/useToast';

/**
 * 新增课程表单
 */
const CourseFormCreate = ({ onBack, onSave, isSaving = false }) => {
  const { statusOptions } = useCourseForm();
  const toast = useToast();

  // 表单字段引用
  const nameRef = useRef(null);
  const teacherRef = useRef(null);
  const statusRef = useRef(null);
  const goalsRef = useRef(null);

  // 处理保存
  const handleSave = () => {
    // 注意：防重入锁由父组件 App.jsx 的 isSavingRef 统一管理，此处不重复判断
    const formData = {
      name: nameRef.current?.value || '',
      teacher: teacherRef.current?.value || '',
      status: statusRef.current?.value || '可用',
      objective: goalsRef.current?.value || '',
    };

    // 验证必填字段
    if (!formData.name || !formData.name.trim()) {
      toast.error('请输入课程名称');
      return;
    }

    onSave(formData);
  };

  return (
    <div className="flex flex-col h-full bg-[#F7FAFC]">
      <header className="h-[56px] px-4 bg-white flex items-center justify-between border-b border-[#EDF2F7] flex-shrink-0">
        <div className="flex items-center gap-2">
          <button onClick={onBack} className="p-1 -ml-1 text-[#2D3748]">
            <ChevronLeft size={24} />
          </button>
          <h1 className="text-lg font-bold text-[#2D3748]">新增课程</h1>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-4 pb-24 space-y-4">
        {/* 基本信息 */}
        <div className="bg-white rounded-xl border border-[#EDF2F7] overflow-hidden">
          {/* 课程名称 */}
          <div className="flex items-center px-4 py-3 border-b border-[#EDF2F7]">
            <label className="w-20 text-sm font-medium text-[#4A5568] flex items-center gap-1">
              课程名称
              <span className="text-red-500">*</span>
            </label>
            <input 
              ref={nameRef}
              type="text" 
              placeholder="请输入课程名称" 
              className="flex-1 text-sm text-right bg-transparent outline-none text-[#2D3748]"
              required
            />
          </div>

          {/* 授课老师 */}
          <div className="flex items-center px-4 py-3 border-b border-[#EDF2F7]">
            <label className="w-20 text-sm font-medium text-[#4A5568]">
              授课老师
            </label>
            <input 
              ref={teacherRef}
              type="text" 
              placeholder="请输入老师姓名" 
              className="flex-1 text-sm text-right bg-transparent outline-none text-[#2D3748]"
            />
          </div>

          {/* 课程状态 */}
          <div className="flex items-center px-4 py-3">
            <label className="w-20 text-sm font-medium text-[#4A5568]">
              课程状态
            </label>
            <select 
              ref={statusRef}
              className="flex-1 text-sm bg-transparent outline-none text-[#2D3748] dir-rtl text-right"
              defaultValue="可用"
            >
              {statusOptions.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
        </div>

        {/* 课程目标 */}
        <div>
          <label className="text-sm font-medium text-[#4A5568] mb-2 block px-1">课程目标</label>
          <textarea 
            ref={goalsRef}
            className="w-full bg-white border border-[#EDF2F7] rounded-xl p-3 text-sm h-32 focus:outline-none focus:border-[#3182CE]" 
            placeholder="请输入课程教学目标..."
          />
        </div>
      </main>

      {/* 底部按钮区 - 新增模式 */}
      <div className="h-[80px] bg-white border-t border-[#EDF2F7] px-6 flex items-center justify-between flex-shrink-0 z-10">
        <Button variant="secondary" onClick={onBack} className="w-32" disabled={isSaving}>取消</Button>
        <Button variant="primary" onClick={handleSave} className="w-32" disabled={isSaving}>
          {isSaving ? '保存中...' : '保存'}
        </Button>
      </div>
    </div>
  );
};

export default CourseFormCreate;
